import React, { useEffect, useState } from "react";
import config from '../../../configs/config';
import { getLanguageSection } from '../../../shared/services/languageService';
import Cookies from 'js-cookie';

function createInitialState() {
  return {
    homePage: Cookies.get('language') === "esp" ? "https://marivalrewards.com/es/" : "https://marivalrewards.com/",
    rewardsPage: Cookies.get('language') === "esp" ? "https://marivalrewards.com/es/rewards_program.html" : "https://marivalrewards.com/rewards_program.html",
    agentPage: "",
    agencyPage: "",
    loginPage: "",
    contactusPage: Cookies.get('language') === "esp" ? "https://marivalrewards.com/es/contactus.html" : "https://marivalrewards.com/contactus.html",
    privacyPage: Cookies.get('language') === "esp" ? "/es/aviso-de-privacidad" : "/privacy-notice",
    cookiePolicyPage: Cookies.get('language') === "esp" ? "/es/politica-de-cookies" : "/cookie-policy"
  };
}

function getCurrentYear() {
  return new Date().getFullYear();
}

function FooterPublic() {
  const [pages, setPages] = useState(createInitialState);

  const language = getLanguageSection('footerpublic');
  const copyright = (language.copyright || '').replace('2023', getCurrentYear());

  useEffect(() => {
    if (Cookies.get('iscanada') === -1) {
      setPages({
        homePage: Cookies.get('language') === "esp" ? "https://marivalrewards.ca/es/" : "https://marivalrewards.ca/",
        rewardsPage: Cookies.get('language') === "esp" ? "https://marivalrewards.ca/es/rewards_program.html" : "https://marivalrewards.ca/rewards_program.html",
        agentPage: "?iscanada=-1",
        agencyPage: "?iscanada=-1",
        contactusPage: Cookies.get('language') === "esp" ? "http://marivalrewards.ca/es/contactus.html" : "http://marivalrewards.ca/contactus.html",
        loginPage: "?iscanada=-1",
        privacyPage: Cookies.get('language') === "esp" ? "/es/aviso-de-privacidad" : "/privacy-notice",
        cookiePolicyPage: Cookies.get('language') === "esp" ? "/es/politica-de-cookies" : "/cookie-policy"
      });
    }
  }, []);

  return (
    <div className="mr-ui mx-auto w-full max-w-7xl px-5 md:px-8">
    <footer className="mt-16 flex flex-wrap items-center justify-between gap-6 border-t border-slate-200 py-8">
      <div className="flex min-w-0 flex-1 basis-80 items-center gap-4">
        <a href="/" className="shrink-0">
          <img src={config.publicurl+'assets/logo/isotipo-marival-agents.svg'} alt="Marival agents" className="w-8"/>
        </a>
        <p className="m-0 text-sm leading-6 text-slate-500">{copyright}</p>
      </div>

      <div className="flex flex-1 basis-96 flex-wrap items-center justify-end gap-x-7 gap-y-4">
        <ul className="m-0 flex list-none flex-wrap items-center justify-end gap-x-6 gap-y-2 p-0">
          <li><a href={pages.cookiePolicyPage} title={language.cookiePolicy} className="whitespace-nowrap text-sm text-slate-600 underline">{language.cookiePolicy}</a></li>
          <li><a href={pages.privacyPage} title={language.privacyPolicy} className="whitespace-nowrap text-sm text-slate-600 underline">{language.privacyPolicy}</a></li>
        </ul>

        <ul className="m-0 flex list-none items-center justify-end gap-4 p-0">
          <li><a href="https://www.facebook.com/MarivalResortsOficial/" target="_blank" rel="noreferrer"><img src={config.publicurl+"assets/icons/facebook.svg"} alt="Facebook Marival resorts" className="w-5 opacity-70 hover:opacity-100"/></a></li>
          <li><a href="https://www.instagram.com/marivalresorts/" target="_blank" rel="noreferrer"><img src={config.publicurl+"assets/icons/instagram.svg"} alt="Instagram Marival resorts" className="w-5 opacity-70 hover:opacity-100"/></a></li>
          <li><a href="https://www.youtube.com/user/marivalchannel" target="_blank" rel="noreferrer"><img src={config.publicurl+"assets/icons/youtube.svg"} alt="Youtube Marival resorts" className="w-5 opacity-70 hover:opacity-100"/></a></li>
        </ul>
      </div>
    </footer>
     </div>
  );
}

export default FooterPublic;
